import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	OnInit,
	Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { catchError, tap } from 'rxjs/operators';

import { throwError } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';
import {
	Column,
	ComponentBox,
	Layout,
} from '@rs-bank/rs-layout';
import { detectChanges } from '@rs-bank/rs-rxjs-extention';

import { ApplicationErrors } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';

import { InternetbankAppApplicationException } from '../../../common/exceptions/exceptions';
import { ConstantsService, InternetBankSettings } from '../../../common/services/constants.service';
import { FieldOptions } from '../../../ui/controls/field.model';
import { PdfIframeControlComponent } from '../../../ui/controls/pdf-iframe-control/pdf-iframe-control.component';
import { DeprecatedPopUpService } from '../../../ui/controls/pop-up/pop-up.service';
import { CustomFormControl } from '../../../ui/custom-reactive-forms/custom-form-control';
import { CustomFormGroup } from '../../../ui/custom-reactive-forms/custom-form-group';
import { BiometricsRegistrationWizardService, CreateAdapterSessionResponse } from '../biometrics-registration-wizard/biometrics-registration-wizard.service';

@Component({
	selector: 'app-biometrics-registration-success-pop-up',
	templateUrl: './biometrics-registration-success.pop-up.component.html',
	styleUrls: ['./biometrics-registration-success.pop-up.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [BiometricsRegistrationWizardService],
	standalone: false,
})
export class BiometricsRegistrationSuccessPopUpComponent extends BaseComponent implements OnInit {
	@Output()
	public closeWindow: EventEmitter<boolean> = new EventEmitter();

	public readonly popUpId = 'biometrics-registration-success-pop-up-id';

	public layout: Layout<Column>;

	public stepIndex: number = 0;

	public resetFormStep1: CustomFormGroup;
	public settings: InternetBankSettings = ConstantsService.SETTINGS;
	public resetActivated: boolean = false;

	public errors: ApplicationErrors | null;

	constructor(
		private modalService: DeprecatedPopUpService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public override changeDetectorRef: ChangeDetectorRef,
		public biometricsRegistrationWizardService: BiometricsRegistrationWizardService,
	) {
		super(changeDetectorRef);
	}


	public openModal(id: string): void {
		this.modalService.open(id);
	}

	public closeModal(id: string): void {
		this.closeWindow.emit(false);
		this.modalService.close(id);
	}

	public load() {
		this.biometricsRegistrationWizardService.loadDocument()
			.pipe(
				tap((data: Blob) => {
					this.updateLayoutPdf(data);
				}),
				catchError((error: InternetbankAppApplicationException) => {
					this.errors = error.errors || null;
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					return throwError((error: any) => error);
				}),
				detectChanges(this),
			)
			.subscribe();
	}

	public ngOnInit(): void {

		this.layout = new Layout(
			new Column([
				new ComponentBox(
					PdfIframeControlComponent,
					(componentInstance: PdfIframeControlComponent) => {
						componentInstance.customFormControl = new CustomFormControl(new FieldOptions({
							'@type': 'pdf-iframe-control',
							name: 'pdfIframeControl',
							required: true,
							height: '70%',
							sidebarVisible: false,
						}));
					},
					{ name: 'pdf' },
				),
			]),
		);

	}

	public showPopUp(): void {
		this.closeWindow.emit(true);

		this.resetPopUpState();
		this.openModal(this.popUpId);

		this.load();

		this.changeDetectorRef.markForCheck();
	}

	public close(): void {
		this.closeModal(this.popUpId);
	}

	public next1(): void {
		this.stepIndex++;
		this.resetErrors();
	}
	public next2(): void {
		this.resetErrors();
		this.biometricsRegistrationWizardService.createAdapterSession()
			.pipe(
				tap((data: CreateAdapterSessionResponse) => {
					window.location.href = data.redirectUrl;
				}),
				catchError((error: InternetbankAppApplicationException) => {
					this.errors = error.errors || null;
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					return throwError((error: any) => error);
				}),
				detectChanges(this),
			)
			.subscribe();
	}

	private updateLayoutPdf(pdfData: Blob): void {
		const pdfControl = this.layout.body.children[0] as ComponentBox<PdfIframeControlComponent>;

		pdfControl.componentInstance$
			.pipe(
				tap((value: PdfIframeControlComponent | undefined) => {
					value?.customFormControl.setValue(pdfData);
					value?.changeDetectorRef.detectChanges();
				}),
			)
			.subscribe();
	}

	private resetPopUpState() {
		this.stepIndex = 0;
		this.resetErrors();
	}

	private resetErrors() {
		this.errors = null;
	}

}
